import type { CSSProperties } from "react";

type FintheonBrandLockupProps = {
  title?: string;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  iconTone?: "grey" | "gold";
  iconSrc?: string;
  iconSize?: number | string;
  gap?: number | string;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
  textStyle?: CSSProperties;
  ariaLabel?: string;
};

const FINTHEON_APP_ICON_PATHS = {
  grey: "brand/fintheon-app-icon-grey.png",
  gold: "fintheon-icon-gold.png",
} as const;

function publicAsset(path: string): string {
  const base = import.meta.env.BASE_URL || "./";
  const safeBase =
    typeof window !== "undefined" &&
    window.location.protocol === "file:" &&
    base === "/"
      ? "./"
      : base;
  return `${safeBase.endsWith("/") ? safeBase : `${safeBase}/`}${path}`;
}

export function FintheonBrandLockup({
  title = "Fintheon",
  className,
  iconClassName,
  textClassName,
  iconTone = "grey",
  iconSrc = publicAsset(FINTHEON_APP_ICON_PATHS[iconTone]),
  iconSize = "1em",
  gap = "0.5em",
  style,
  iconStyle,
  textStyle,
  ariaLabel,
}: FintheonBrandLockupProps) {
  return (
    <span
      aria-label={ariaLabel ?? title}
      className={className}
      data-fintheon-brand-lockup="true"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap,
        minWidth: 0,
        ...style,
      }}
    >
      <img
        aria-hidden="true"
        alt=""
        className={iconClassName}
        draggable={false}
        src={iconSrc}
        style={{
          width: iconSize,
          height: iconSize,
          flex: "0 0 auto",
          objectFit: "contain",
          ...iconStyle,
        }}
      />
      <span className={textClassName} style={{ minWidth: 0, ...textStyle }}>
        {title}
      </span>
    </span>
  );
}
